export default "__VITE_ASSET__956fe8e7__"